// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interacted {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  margin-left: 10px;
  font-size: 11px;
}
.interacted span.interacted-user {
  color: var(--ion-color-text-color);
  font-weight: bold;
}
.interacted img {
  width: 17px;
  height: 17px;
  object-fit: cover;
  border-radius: 12px;
  margin-right: 6px;
}
.interacted ion-icon {
  margin-left: 5px;
}

ion-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.interacted:first-child {
  margin-top: 10px;
}

.interacted:last-child {
  margin-bottom: 2px;
}

.interacted-box {
  padding: 0;
  background: var(--ion-color-secondary-contrast);
  border-bottom: 1px var(--ion-color-light-tint) solid;
}
@media only screen and (min-width: 460px) {
  .interacted-box {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}

ion-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.interacted-outer-div {
  display: flex;
}

.interacted-user {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70px;
}

.interacted-user-team {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 110px;
}

.rest-content {
  position: relative;
  margin-top: -1.6px;
}

.rest-content-team {
  position: relative;
}

ion-col {
  text-align: left;
}

.p-0 {
  padding: 0;
}

.m-0 {
  margin: 0;
}

.interaction-icons {
  cursor: pointer;
  position: absolute;
  margin-top: 3px;
}

.interacted-outer-div .interaction-icons {
  position: relative;
  margin-top: 3px;
}

button.moreOrLess {
  line-height: 1;
  padding: 0 4px;
  font-size: 11px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  background: transparent;
  color: #888888;
  height: 11px;
  margin-left: auto;
  margin-right: 10px;
  margin-bottom: 10px;
  justify-content: flex-end;
}
@media only screen and (max-width: 460px) {
  button.moreOrLess {
    margin-left: 0;
    padding: 0;
    width: 100%;
  }
}

div.youSeeThat {
  font-size: 11px;
  margin-bottom: -2px;
  padding-top: 5px;
  margin-left: 10px;
}

.lessButton {
  line-height: 1;
  padding: 0 4px;
  font-size: 11px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  background: transparent;
  color: #888888;
  height: 11px;
  margin-left: auto;
  margin-right: 10px;
  margin-bottom: 10px;
}

.post-team-interaction {
  align-items: center;
  display: flex;
  padding-bottom: 2px;
}

.interacted-data {
  margin-bottom: 6px;
}
@media only screen and (min-width: 2560px) {
  .interacted-data {
    margin-left: -10px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
